import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { Container } from 'react-bootstrap';
import { AuthProvider } from './contexts/AuthContext';
import ProtectedRoute from './components/ProtectedRoute';
import AdminRoute from './components/AdminRoute';
import Header from './components/Layout/Header';
import Footer from './components/Layout/Footer';

// 頁面
import Login from './pages/Auth/Login';
import OrderList from './pages/Order/OrderList';
import OrderDetail from './pages/Order/OrderDetail';
import NewOrder from './pages/Order/OrderNew';
import EditOrder from './pages/Order/EditOrder';
import Profile from './pages/Account/Profile';
import UserList from './pages/User/UserList';
import UserForm from './pages/User/UserForm';
import CustomerList from './pages/Customer/CustomerList';
import CustomerForm from './pages/Customer/CustomerForm';
import CustomerSchedule from './pages/Customer/CustomerSchedule';
import CustomerRelations from './pages/Customer/CustomerRelations';
import TermsAndConditions from './pages/TermsAndConditions/TermsAndConditions';

import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="app">
          <Routes>
            <Route path="/login" element={<Login />} />
            
            <Route path="/" element={<ProtectedRoute><Header /><Footer /></ProtectedRoute>}>
              <Route index element={<Navigate to="/orders/new" replace />} />
              <Route path="orders" element={<OrderList />} />
              <Route path="orders/new" element={<NewOrder />} />
              <Route path="orders/:orderId" element={<OrderDetail />} />
              <Route path="orders/edit/:orderId" element={<EditOrder />} />
              <Route path="profile" element={<Profile />} />
              
              {/* 用戶管理路由 */}
              <Route path="users" element={<AdminRoute><UserList /></AdminRoute>} />
              <Route path="users/new" element={<AdminRoute><UserForm /></AdminRoute>} />
              <Route path="users/edit/:userId" element={<AdminRoute><UserForm /></AdminRoute>} />
              
              {/* 客戶管理路由 */}
              <Route path="customers" element={<AdminRoute><CustomerList /></AdminRoute>} />
              <Route path="customers/new" element={<AdminRoute><CustomerForm /></AdminRoute>} />
              <Route path="customers/edit/:custCode" element={<AdminRoute><CustomerForm /></AdminRoute>} />
              <Route path="customers/:custCode/schedule" element={<AdminRoute><CustomerSchedule /></AdminRoute>} />
              <Route path="customers/:custCode/relations" element={<AdminRoute><CustomerRelations /></AdminRoute>} />
              <Route path="terms-and-conditions" element={<TermsAndConditions />} />
            </Route>
            
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;